<template>
  <tr>
    <td class="py-2.5 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 border-0">
      <label class="flex items-center gap-x-2">
        <input :disabled="!file.bucket" type="checkbox" :name="file.id" v-model="selected"
          class="form-checkbox h-4 w-4">
        <span class="block truncate max-w-[350px]" :title="file.title">{{ file.title }}</span>
      </label>
    </td>
    <td class="py-2.5 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 border-0">
      <p class="uppercase w-max mb-0 text-xs truncate max-w-[300px] bg-slate-200 px-2 py-1 text-slate-700 rounded"
        :title="file.courseTitle">
        {{ file.courseTitle }}
      </p>
    </td>
    <td class="py-2.5 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 border-0" :class="typeColor">
      <div class="flex gap-x-1 items-center">
        <svg-icon :name="iconClass" classes="size-5" />
        <span class="text-slate-700 text-sm">{{ file.kind }}</span>
      </div>
    </td>
    <td class="py-2.5 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 border-0">{{ bytesToSize }}</td>
    <td class="py-2.5 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 border-0">
      <a :href="selectedFileCount > 1 ? 'javascript:void(0)' : file.url" target="_blank" rel="noreferrer"
        class="inline-flex items-center gap-x-1 uppercase text-sm bg-teal-600 !text-slate-100 no-underline px-2 py-1 rounded hover:bg-teal-700"
        :class="{ 'cursor-not-allowed opacity-50 pointer-events-none': selectedFileCount > 1 || !file.bucket }"
        :download="file.title">
        <span>Download</span>
        <svg-icon name="file-download-line" classes="size-4" />
      </a>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'assetBrowserFile',

  data() {
    return {
      selected: this.checked
    }
  },

  props: {
    file: {
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    selectedFileCount: {
      type: Number,
      required: true
    }
  },

  watch: {
    checked: function (val) {
      this.selected = val
    },
    selected: function (val) {
      this.selectFile(val, this.file)
    },
    selectedFileCount(newCount) {
      if (newCount === 0) this.selected = false
    }
  },

  computed: {
    iconClass() {
      switch (this.file.kind) {
        case "pdf":
          return "file-pdf-line"
        case "excel":
          return "file-excel-line"
        case "text":
          return "file-text-line"
        case "word":
          return "file-word-line"
        default:
          return "file-line"
      }
    },
    typeColor() {
      switch (this.file.kind) {
        case "pdf":
          return "text-red-600"
        case "excel":
          return "text-green-600"
        case "text":
          return "text-slate-600"
        case "word":
          return "text-blue-600"
        default:
          return "text-slate-600"
      }
    },
    bytesToSize() {
      const bytes = this.file.size;
      if (!bytes || bytes == 0) return ''

      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      if (i == 0) return bytes + ' ' + sizes[i];
      return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }
  },

  methods: {
    selectFile(checked) {
      // don't select files that aren't in S3, they can't be zipped
      if (this.file.bucket) {
        // update module count
        this.$emit('updateFileCount', checked ? 1 : -1);

        // update main file list
        this.emitter.emit('selectfile', {
          checked: checked,
          file: this.file
        });
      }
    }
  }
}
</script>
